<template>
  <RouterView />
  <div class="pointer-events-none fixed right-5 top-5 z-[200] flex w-[min(440px,calc(100vw-2.5rem))] flex-col items-stretch gap-3">
    <div
      v-for="item in toast.items"
      :key="item.id"
      class="pointer-events-auto flex items-start gap-3 rounded-lg border px-5 py-4 shadow-[0_12px_32px_rgba(0,0,0,0.45)]"
      :class="{
        'border-emerald-400/40 bg-[#10261c] text-emerald-100': item.variant === 'success',
        'border-sky-400/40 bg-[#102033] text-sky-100': item.variant === 'info',
        'border-amber-400/40 bg-[#2a1f0e] text-amber-100': item.variant === 'warning',
        'border-rose-400/40 bg-[#2a1218] text-rose-100': item.variant === 'error',
      }"
    >
      <p class="min-w-0 flex-1 text-2xl font-semibold leading-snug tracking-wide">{{ item.message }}</p>
      <button
        type="button"
        class="mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-3xl leading-none opacity-80 transition hover:bg-white/10 hover:opacity-100"
        aria-label="关闭"
        @click="toast.dismiss(item.id)"
      >
        ×
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import { toast } from '@/lib/toast'
</script>
